import { api } from '../../../shared/services/api/client';
import { createLogger } from '../../../shared/config/logger';

const logger = createLogger('onlinePresenceApi');

const PRESENCE_API_URL = process.env.REACT_APP_PRESENCE_API_URL || '';

/**
 * Fetch presence summary from astraweb-online-presence-backend.
 * Uses the same Bearer token as the rest of the app (Supabase JWT).
 * @returns {Promise<{ merchant, inputs, audit, scores, highlights, tasks }>}
 * @throws on network or non-2xx response
 */
export async function fetchPresenceSummary() {
    if (!PRESENCE_API_URL) {
        throw new Error('REACT_APP_PRESENCE_API_URL is not set');
    }
    const url = `${PRESENCE_API_URL.replace(/\/$/, '')}/v1/presence/summary`;
    logger.debug('Fetching presence summary', { url });
    const { data } = await api.get(url);
    return data;
}

export const hasPresenceApiConfigured = Boolean(PRESENCE_API_URL);
